// TODO 先如此 之后优化
import enUS from "../components/complex-picker/locale/en-US";
import zhCN from "../components/complex-picker/locale/zh-CN";

const languages = { 'en-US': enUS, 'zh-CN': zhCN };
let language = ""; // enUS zhCN

export function getLang(): string {
  if (language) return language;

  const userAgent = navigator.userAgent.split(/\s+/);
  let item =
    userAgent.find((item) => {
      return /Yachlang/i.test(item);
    }) || "";
  language = item.replace(/Yachlang\//i, "") || "zh-CN";

  // language = item.replace("-", "");
  return language;
}

export function isLang(lang: string) {
  return getLang() === lang;
}

export function isEN() {
  return isLang('en-US');
}

export function isZH() {
  return isLang('zh-CN');
}

getLang();

export default (key: string) => {
  return languages[language]["lang"][key];
};
